<template>
  <template v-if="widget.multi">
    <a-tag v-for="(item, k) in values" :key="k" @click="() => open(item)" style="cursor: pointer">
      {{ item.label || item.value }}
    </a-tag>
  </template>
  <template v-else>
    <sc-btn
      v-for="(item, k) in values"
      :key="k"
      :text="item.label || item.value"
      type="link"
      :handler="() => open(item)"
    />
  </template>
</template>

<script lang="ts" setup>
import { computed, defineProps } from 'vue';
import { windows } from '@/components/common/window/Windows';
import _ from 'lodash';
import { SelectRemoteFieldType } from '@/components/business/crud/interface/FieldType';
import { WidgetInfo } from '@/components/business/crud/widgets/WidgetContainer';
import ScBtn from '@/components/common/widget/ScBtn.vue';
import { ColumnEdit } from '@/components/business/crud/widgets/TableWidgetContainer';

const props = defineProps<{
  columnEdit?: ColumnEdit;
  propName: string;
  widget: SelectRemoteFieldType;
  info: WidgetInfo;
  data: any;
}>();
const values = computed(() => {
  if (props.widget.multi) {
    return (
      props.data[props.propName]?.list.map((i: any) => {
        return {
          label: i[props.widget.labelFieldName],
          value: i[props.widget.valueFieldName],
        };
      }) || []
    );
  } else {
    if (props.data[props.propName]) {
      return [
        {
          label: _.get(props.data, [
            props.propName,
            props.widget.labelFieldName,
          ]),
          value: _.get(props.data, [
            props.propName,
            props.widget.valueFieldName,
          ]),
        },
      ];
    } else {
      return [];
    }
  }
});

function open(item: { value: string }) {
  if (item?.value && props.widget.viewPagePath) {
    windows.open({
      content: {
        type: 'route',
        href: props.widget.viewPagePath.replace('__value__', item.value),
      },
      title: props.info.title + '详情',
    });
  }
}
</script>

<style lang="scss" scoped></style>
